import { environment } from './environment';

export const Endpoints = {
  demo: {
    colors: `${environment.baseUrl}/unknown`,
  },
  security: {
    login: `${environment.baseUrl}/login?delay=2`,
  },
  sse: {
    base: `${environment.sse.url}`,
  },
  users: {
    base: `${environment.usersURL}`,
    menu: `${environment.usersURL}/menu/email`,
    tutors: `${environment.usersURL}/tutor`,
    student: `${environment.usersURL}/student`,
  },
  modules: {
    module: `${environment.catalogsURL}/module`,
    submodule: `${environment.catalogsURL}/submodule`,
    service: `${environment.catalogsURL}/service`,
    menu: `${environment.catalogsURL}/menu`,
  },
  catalogs: {
    campus: `${environment.catalogsURL}/campus`,
    roles: `${environment.catalogsURL}/role`,
    dwh: `${environment.catalogsURL}/dwh`,
    roluser: `${environment.catalogsURL}/roluser`,
    libraries: `${environment.catalogsURL}/libraries`,
    params: `${environment.catalogsURL}/parameters`,
    base: `${environment.catalogsURL}`,
    typeFile: `${environment.catalogsURL}/typefile`,
    typeFileExtension: `${environment.catalogsURL}/typefile/prorogation`,
    relationship: `${environment.catalogsURL}/parent`,
    serviceAction: `${environment.catalogsURL}/service/action`,
    templateParams: `${environment.catalogsURL}/template`,
    validationIa: `${environment.catalogsURL}/ia`,
    extension: `${environment.catalogsURL}/prorogation`,
    images: `${environment.catalogsURL}/imagesystem`,
    sections: `${environment.catalogsURL}/section`,
    serviceParams: `${environment.catalogsURL}/procedures`,
    personalDoc: `${environment.catalogsURL}/personaldocument`,
    personalDocParams: `${environment.catalogsURL}/sectiondocument`,
    campusBanner: `${environment.catalogsURL}/campusbanner`,
    blacklist: `${environment.catalogsURL}/blacklist`,
  },
  library: {
    base: `${environment.libraryURL}`,
  },
  digitalFile: {
    base: `${environment.digitalFileURL}`,
    masive: `${environment.digitalFileMasiveURL}`,
    periods: `${environment.digitalFileMasiveURL}/periods`,
    rejection_reasons: `${environment.digitalFileURL}/rejectionreasons`,
  },
  calendars: {
    types: `${environment.calendarsURL}/typecalendar`,
    admin: `${environment.calendarsURL}/admincalendar`,
  },
  notifications: {
    base: `${environment.notificationURL}/notifications`,
    transactional: `${environment.notificationURL}/transactional`,
    templates: `${environment.notificationURL}/templates`,
    letters: `${environment.notificationURL}/letters`,
    whatsapp: `${environment.notificationURL}/whatsapp`,
  },
  recordLog: {
    base: `${environment.recordLogURL}`,
    binnacle: `${environment.recordLogURL}/binnacle`,
    students: `${environment.recordLogURL}/studentlog`,
    payments: `${environment.recordLogURL}/paymentbinnacle`,
    virtualstore: `${environment.recordLogURL}/virtualstore`,
  },
  config: {
    domain: `${environment.configURL}/domain`,
    binnacle: `${environment.configURL}/binnacle`,
  },
  student: {
    base: `${environment.studentURL}`,
    credential: `${environment.studentURL}/credential`,
    featureManagement: `${environment.studentURL}/funcionality`,
  },
  tipification: {
    base: `${environment.tipificationsURL}`,
    settings: `${environment.tipificationsURL}/tipifications`,
  },
  monitor: {
    base: `${environment.monitoringURL}`,
    crm: `${environment.monitoringURL}/crm`,
    activity: `${environment.monitoringURL}/activity`,
  },
  constancy: {
    base: `${environment.constancyURL}`,
  },
  tags: {
    base: `${environment.constancyURL}/labels`,
  },
  sections: {
    base: `${environment.constancyURL}/sections`,
  },
  originPush: {
    base: `${environment.catalogsURL}/codesites`,
  },
  reportCard: {
    base: `${environment.studentURL}/configreportcard`,
  },
  payments: {
    base: `${environment.paymentURL}`,
  },
  surveys: {
    base: `${environment.surveyURL}`,
  },
};

export const TokenExcludedEndpoints = ['login'];
